import React from 'react';
import { ClinicInfoPanel } from '../info/clinicInfoParts';

const SkeletonLine = ({ className = '' }) => (
    <div className={`clinic-settings-skeleton__line ${className}`.trim()} />
);

function HoursSkeleton() {
    return (
        <ClinicInfoPanel title="Weekly Schedule" icon="bi-calendar-week">
            <div className="clinic-settings-skeleton">
                {Array.from({ length: 7 }).map((_, index) => (
                    <div key={`hours-skeleton-${index}`} className="clinic-settings-skeleton__row card">
                        <SkeletonLine className="clinic-settings-skeleton__line--short" />
                        <SkeletonLine className="clinic-settings-skeleton__line--medium" />
                    </div>
                ))}
            </div>
        </ClinicInfoPanel>
    );
}

export default HoursSkeleton;
